import { createSlice } from '@reduxjs/toolkit';
import { fetchSavedDeliverySettings, logoutUser, logoutAdmin } from '~/api';
import { UserJudgment } from '~/common/types';

// ユーザには知られるとまずい内容なので、initialStateはnullでkey名も保持しない
type UserJudgmentState = {
  userJudgement: UserJudgment | null;
};

const initialState: UserJudgmentState = {
  userJudgement: null,
};

const judgementSlice = createSlice({
  name: 'judgement',
  initialState,
  reducers: {
    initialize: () => initialState,
  },
  // 非同期はextraReducersで行う
  extraReducers: (builder) => {
    builder
      .addCase(fetchSavedDeliverySettings.fulfilled, (state, action) => ({
        ...state,
        userJudgement: action.payload.judgement as UserJudgment | null,
      }))
      .addCase(logoutAdmin.fulfilled, () => initialState)
      .addCase(logoutUser.fulfilled, () => initialState);
  },
});

export const { initialize } = judgementSlice.actions;

// reducerをexportする
export default judgementSlice.reducer;
